var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33301 11C8.78073 11 8.33301 11.4477 8.33301 12C8.33301 12.5523 8.78073 13 9.33301 13H15.9997C16.5519 13 16.9997 12.5523 16.9997 12C16.9997 11.4477 16.5519 11 15.9997 11H9.33301Z",
    fill: "url(#paint0_linear_39_11181)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33301 16.3333C8.78073 16.3333 8.33301 16.7811 8.33301 17.3333C8.33301 17.8856 8.78073 18.3333 9.33301 18.3333H19.9997C20.5519 18.3333 20.9997 17.8856 20.9997 17.3333C20.9997 16.7811 20.5519 16.3333 19.9997 16.3333H9.33301Z",
    fill: "url(#paint1_linear_39_11181)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.667 1.66666C7.48729 1.66666 1.66699 7.48695 1.66699 14.6667C1.66699 21.8464 7.48729 27.6667 14.667 27.6667C17.8965 27.6667 20.8523 26.488 23.1251 24.5391L28.6266 30.0404C29.0171 30.4309 29.6502 30.4309 30.0407 30.0404C30.4313 29.6499 30.4313 29.0168 30.0407 28.6263L24.5394 23.1248C26.4883 20.852 27.667 17.8961 27.667 14.6667C27.667 7.48695 21.8467 1.66666 14.667 1.66666ZM3.66699 14.6667C3.66699 8.59152 8.59186 3.66666 14.667 3.66666C20.7421 3.66666 25.667 8.59152 25.667 14.6667C25.667 17.7045 24.4369 20.4532 22.4451 22.4448C20.4535 24.4365 17.7049 25.6667 14.667 25.6667C8.59186 25.6667 3.66699 20.7417 3.66699 14.6667Z",
    fill: "url(#paint2_linear_39_11181)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_39_11181",
    x1: 12.6663,
    y1: 11,
    x2: 12.6663,
    y2: 13.4231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744792,
    stopColor: "white",
    stopOpacity: 0.364583
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_39_11181",
    x1: 14.6663,
    y1: 16.3333,
    x2: 14.6663,
    y2: 18.7565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744792,
    stopColor: "white",
    stopOpacity: 0.364583
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_39_11181",
    x1: 16.0003,
    y1: 1.66666,
    x2: 16.0003,
    y2: 36.3983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744792,
    stopColor: "white",
    stopOpacity: 0.364583
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon03);
export default __webpack_public_path__ + "static/media/icon-03.503cf24708903adbb6ab0fd959fd35a5.svg";
export { ForwardRef as ReactComponent };